import React from 'react';

/**
 * SectionTitle — Título de sección alineado a la izquierda con línea divisoria
 * estética hacia la derecha y acción "Ver todo" en negrita al extremo derecho.
 *
 * Uso:
 *   <SectionTitle>Combos y promociones</SectionTitle>
 *   <SectionTitle accion="Ver todo" onAccion={() => ...}>Salud hepática y detox</SectionTitle>
 */
const SectionTitle = ({ children, accion, onAccion }) => (
  <div style={{
    display: 'flex',
    alignItems: 'center',
    gap: 'var(--space-3)',
    marginBottom: 'var(--space-4)',
    width: '100%',
  }}>
    {/* Título alineado a la izquierda */}
    <h2 style={{
      fontFamily: 'var(--font-display)',
      fontSize: 'var(--font-size-h2)',
      fontWeight: 'var(--font-weight-black)',
      color: 'var(--text-primary)',
      letterSpacing: 'var(--letter-spacing-tight)',
      lineHeight: 'var(--line-height-tight)',
      textAlign: 'left',
      margin: 0,
    }}>
      {children}
    </h2>

    {/* Línea divisoria estética hacia la derecha */}
    <div
      aria-hidden="true"
      style={{
        flex: 1,
        height: '1px',
        backgroundColor: 'var(--border-default)',
        minWidth: '16px',
      }}
    />

    {/* Botón de acción (Ver todo en negrita) al extremo derecho */}
    {accion && (
      <button
        type="button"
        onClick={onAccion}
        className="section-title-btn"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '4px',
          background: 'none',
          border: 'none',
          color: 'var(--color-verde)',
          fontFamily: 'var(--font-body)',
          fontSize: 'var(--font-size-xs)',
          fontWeight: 'var(--font-weight-black)',
          letterSpacing: '0.01em',
          cursor: 'pointer',
          padding: '4px 0',
          flexShrink: 0,
          whiteSpace: 'nowrap',
          WebkitTapHighlightColor: 'transparent',
          transition: 'color var(--transition-fast), opacity var(--transition-fast)',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.color = 'var(--color-verde-hover)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.color = 'var(--color-verde)';
        }}
      >
        <span style={{ fontWeight: 'var(--font-weight-black)' }}>{accion}</span>
        <svg
          width="13"
          height="13"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M9 6l6 6-6 6"/>
        </svg>
      </button>
    )}
  </div>
);

export default SectionTitle;
